import defaultReducers from '@models/defaultReducers'
import { UiFlags } from '@src/types'
import { UiFlagsStoreState } from './types'

const reducers = {
  ...defaultReducers,

  setUiFlags: (state: UiFlagsStoreState, { payload }: { payload: UiFlags }) => {
    return {
      ...state,
      uiFlags: payload,
    }
  },

  updateUiFlags: (state: UiFlagsStoreState, { payload }: { payload: Partial<UiFlags> }) => {
    return {
      ...state,
      uiFlags: {
        ...state.uiFlags,
        ...payload,
      },
    }
  },
}

export default reducers
